import { useRef, useState } from "react";

/** MUI */
import { Button, ButtonGroup } from "@mui/material";
import { makeStyles } from "@mui/styles";
/** - icons */
import { Icon } from "@/src/components/Icons";

/** Helpers */
import clsx from "clsx";
import { useTranslation } from "react-i18next";

/** UI */
import AppTooltip from "@/src/_common/AppTooltip";

const orders = [
    {
        value: "asc",
        label: "Rosnąco",
        label_en: "From A to Z",
    },
    {
        value: "desc",
        label: "Malejąco",
        label_en: "From Z to A",
    },
];

const useStyles = makeStyles((theme) => ({
    input: {
        display: "flex",
    },
    iconLI: {
        [theme.breakpoints.down("sm")]: {
            minWidth: "unset",
        },
    },
    InputRoot: {
        [theme.breakpoints.down("lg")]: {
            fontSize: "0.88888889rem",
        },
    },
    menuItem: {
        [theme.breakpoints.down("lg")]: {
            fontSize: "0.88888889rem",
        },
    },
    button: {
        padding: theme.spacing(1),
        borderRadius: 4,
        height: 40,
    },
    buttonActive: {
        boxShadow:
            "inset 0px 3px 1px -2px rgba(0,0,0,0.2), inset 0px 2px 2px 0px rgba(0,0,0,0.14), inset 0px 1px 5px 0px rgba(0,0,0,0.12)!important",
    },
}));

const SelectOrder = (props) => {
    const { column, id, order = "asc", onChangeOrder } = props;

    const focusTrap = useRef();

    const classes = useStyles();

    const { t } = useTranslation();

    /** States */
    const [ORDER, setORDER] = useState(order);
    const [OPEN_TIP, setOPEN_TIP] = useState(false);

    /** Handlers */
    const handleChangeOrder = (order, type) => {
        focusTrap.current = `${id}-${type}`;
        onChangeOrder({ id, order });
        setORDER(order);
    };

    return (
        <>
            <ButtonGroup variant={"contained"} size={"small"} sx={{ boxShadow: "none" }}>
                {orders.map((option) => {
                    if (option.value === "asc") {
                        return (
                            <AppTooltip
                                key={`${id}-asc`}
                                title={t("Ustaw rosnąco")}
                                arrow
                                placement={"top"}
                                type={"dark"}
                                open={!!(OPEN_TIP === `${id}-asc`)}
                                onOpen={() => {
                                    setOPEN_TIP(`${id}-asc`);
                                }}
                                onClose={() => {
                                    setOPEN_TIP(false);
                                }}
                                onKeyDown={(event) => {
                                    if (event?.keyCode === 27) setOPEN_TIP(false);
                                }}
                            >
                                <Button
                                    className={clsx(classes.button, option.value === ORDER && classes.buttonActive)}
                                    onClick={() => handleChangeOrder(option.value, "desc")}
                                    disabled={option.value === ORDER}
                                    id={`${id}-asc`}
                                    ref={(ref) => {
                                        if (ref) {
                                            if (ref?.id === focusTrap.current) {
                                                ref.focus();
                                            }
                                        }
                                    }}
                                    onKeyDownCapture={(e) => {
                                        if (e?.key === "Tab") {
                                            focusTrap.current = "";
                                            setOPEN_TIP(false);
                                        }
                                    }}
                                    onBlur={() => {
                                        setOPEN_TIP(false);
                                    }}
                                >
                                    <Icon icon="bx:sort-up" width="24" height="24" />
                                </Button>
                                {/* </span> */}
                            </AppTooltip>
                        );
                    }

                    if (option.value === "desc") {
                        return (
                            <AppTooltip
                                key={`${id}-desc`}
                                title={t("Ustaw malejąco")}
                                arrow
                                placement={"top"}
                                type={"dark"}
                                open={!!(OPEN_TIP === `${id}-desc`)}
                                onOpen={() => {
                                    setOPEN_TIP(`${id}-desc`);
                                }}
                                onClose={() => {
                                    setOPEN_TIP(false);
                                }}
                                onKeyDown={(event) => {
                                    if (event?.keyCode === 27) setOPEN_TIP(false);
                                }}
                            >
                                <Button
                                    className={clsx(classes.button, option.value === ORDER && classes.buttonActive)}
                                    onClick={() => handleChangeOrder(option.value, "asc")}
                                    disabled={option.value === ORDER}
                                    id={`${id}-desc`}
                                    ref={(ref) => {
                                        if (ref) {
                                            if (ref?.id === focusTrap.current) {
                                                ref.focus();
                                            }
                                        }
                                    }}
                                    onKeyDownCapture={(e) => {
                                        if (e?.key === "Tab") {
                                            focusTrap.current = "";
                                            setOPEN_TIP(false);
                                        }
                                    }}
                                    onBlur={() => {
                                        setOPEN_TIP(false);
                                    }}
                                >
                                    <Icon icon="bx:sort-down" width="24" height="24" />
                                </Button>
                            </AppTooltip>
                        );
                    }
                })}
            </ButtonGroup>
        </>
    );
};

export default SelectOrder;

// t("asc")
// t("desc")
